<template>
  <b-card
    no-body
  >
    <tabs-menu
      :menu="menuTabs"
      :active="activeTabs"
      class="mb-0"
    />

    <ExternalProduct v-if="activeTabs === 1" />

    <MiniapolyProduct v-if="activeTabs === 2" />

    <UserRegistry v-if="activeTabs === 3" />

  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ExternalProduct from '@/layouts/components/table/dashboard/ExternalProduct.vue'
import MiniapolyProduct from '@/layouts/components/table/dashboard/MiniapolyProduct.vue'
import UserRegistry from '@/layouts/components/table/dashboard/UserRegistry.vue'
import TabsMenu from '@/layouts/components/custom/TabsMenu.vue'

export default {
  components: {
    BCard,
    ExternalProduct,
    MiniapolyProduct,
    UserRegistry,
    TabsMenu,
  },
  directives: {
    Ripple,
  },
  computed: {
    activeTabs() {
      return this.$route.query.tab ? parseInt(this.$route.query.tab, 0) : 1
    },
    menuTabs() {
      return [
        {
          access: null,
          title: 'Produk External',
          action: null,
          payload: null,
          otherAction: null,
          otherQuery: null,
        },
        {
          access: null,
          title: 'Produk Miniapoly',
          action: null,
          payload: null,
          otherAction: null,
          otherQuery: null,
        },
        {
          access: null,
          title: 'User Registry',
          action: null,
          payload: null,
          otherAction: null,
          otherQuery: null,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
$primary: #7367f0;

.product-info {
  display: flex;
  &__image {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 8px;
  }
}

.product-list {
  &__tabs {
    display: flex;
  }
  &__filters {
    padding: 16px 20px;
    font-size: 14px !important;
  }
  &__footer {
    padding: 16px 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.tab-item {
  padding: 12px 28px;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  font-weight: 500;
  color: #bdbdbd;
  &:hover {
    cursor: pointer;
    color: $primary;
  }
  &.active {
    color: $primary;
    border-color: $primary;
  }
}
</style>
